
import eventTrackingMixins from '~/mixins/eventTrackingMixins.js';
import compareProductsDisplay from '~/mixins/product-comparison/compareProductsDisplay.js';
import compareProductsActions from '~/mixins/product-comparison/compareProductsActions.js';

export default {
  name: 'ComparisonSticky',
  mixins: [compareProductsDisplay, compareProductsActions, eventTrackingMixins],

  computed: {
    productsToCompareForDisplay() {
      return this.productsToCompare.slice(0, this.noOfProductsToDisplay);
    }
  },

  methods: {
    handleEventTracking_compareButton(event) {
      const dataFromClickedElement = this.extractDataFromClickedElement(event.target);
      const dataFromProductMainPage = this.extractDataFromCurrentProductMainPage();
      const eventTrackingParams = this.initEventTrackingParams();

      if (dataFromClickedElement.tracking_target.target_code === 'product-compare-button') {
        // #17 decoder_compare_panel

        const cardSelectedData = {
          combined: {
            insurance_company: '',
            product_scenarioCode: '',
            product_name: '',
            product_category: ''
          }
        };
        this.productsToCompare?.forEach((item) => {
          const data = item;
          if (data) {
            cardSelectedData.combined.insurance_company = `${
              cardSelectedData.combined.insurance_company ? cardSelectedData.combined.insurance_company + ',' : ''
            }${data?.insurnanceName}`;
            cardSelectedData.combined.product_scenarioCode = `${
              cardSelectedData.combined.product_scenarioCode ? cardSelectedData.combined.product_scenarioCode + ',' : ''
            }${data?.id}`;
            cardSelectedData.combined.product_name = `${
              cardSelectedData.combined.product_name ? cardSelectedData.combined.product_name + ',' : ''
            }${data?.productName}`;
            cardSelectedData.combined.product_category = `${dataFromProductMainPage.product.product_category}`;
          }
        });

        const insuranceCompany = cardSelectedData.combined.insurance_company;
        const productScenarioCode = cardSelectedData.combined.product_scenarioCode;
        const productName = cardSelectedData.combined.product_name;
        const productCategory = cardSelectedData.combined.product_category;
        eventTrackingParams.a = 'compare';
        eventTrackingParams.l = productScenarioCode;
        eventTrackingParams.c = `decoder_compare_panel`;
        eventTrackingParams.cd.insurer_name = insuranceCompany;
        eventTrackingParams.cd.product_name = productName;
        eventTrackingParams.cd.product_category = productCategory;
      }

      this.sendEventTracking(eventTrackingParams);
    }
  }
};
